import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
    user_accounts: [],
    visible_user: {},
    auth_user: {},
};

let userModule = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};

export default userModule;


// WEBPACK FOOTER //
// ./resources/assets/js/vuex/modules/user/index.js